module.exports = __webpack_public_path__ + "img/icon_speechbubble_black.8a56034.svg";